import BaseError from './BaseError'

export default class GenericException<Data = unknown> extends BaseError<Data> {
  constructor(info: {
    name: string
    message: string
    action: string
    stack?: string
    data?: Data
    cause?: unknown
  }) {
    super(info)
  }
}
